import {
  Badge,
  Box,
  Button,
  Card,
  CardBody,
  HStack,
  Icon,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useRef } from "react";
import { FaFileExcel, FaFileUpload, FaInfoCircle } from "react-icons/fa";

export default function ExcelUploadField({
  excelData,
  excelFileName,
  handleExcelUpload,
  removeExcelFile,
  t,
}) {
  const fileInputRef = useRef(null);

  return (
    <Card bg="yellow.50" border="1px solid" borderColor="yellow.200" borderRadius="md" boxShadow="sm" mt={1}>
      <CardBody p={2}>
        <VStack spacing={1} align="stretch">
          <HStack justify="space-between" align="center">
            <HStack spacing={1}>
              <Icon as={FaFileExcel} color="yellow.600" />
              <Text fontSize="xs" fontWeight="semibold" color="gray.700">
                {t("reports.uploadExcelFiles", "رفع بيانات من ملف Excel")}
              </Text>
            </HStack>
            <Badge colorScheme="yellow" variant="subtle" fontSize="xs">
              {t("reports.optional", "اختياري")}
            </Badge>
          </HStack>
          {!excelFileName ? (
            <Box
              border="2px dashed"
              borderColor="yellow.300"
              borderRadius="sm"
              p={1}
              textAlign="center"
              cursor="pointer"
              _hover={{ bg: "yellow.100", borderColor: "yellow.400" }}
              onClick={() => fileInputRef.current?.click()}
            >
              <HStack spacing={1} justify="center">
                <Icon as={FaFileUpload} boxSize={2} color="yellow.500" />
                <Text fontWeight="medium" color="yellow.700">
                  {t("reports.clickToUpload", "انقر لرفع ملف Excel")}
                </Text>
              </HStack>
              <input
                ref={fileInputRef}
                type="file"
                accept=".xlsx,.xls,.csv"
                style={{ display: "none" }}
                onChange={(event) => handleExcelUpload(event.target.files?.[0])}
              />
            </Box>
          ) : (
            <Box border="1px solid" borderColor="green.200" borderRadius="md" p={2} bg="green.50">
              <HStack justify="space-between" align="center">
                <HStack spacing={1}>
                  <Icon as={FaFileExcel} color="green.500" />
                  <VStack align="flex-start" spacing={0}>
                    <Text fontWeight="medium" fontSize="sm">
                      {excelFileName}
                    </Text>
                    <Text fontSize="xs" color="gray.500">
                      {t("reports.readyForAnalysis", "جاهز للتحليل")}
                    </Text>
                  </VStack>
                </HStack>
                <HStack spacing={1}>
                  <Badge colorScheme="green" fontSize="xs">
                    {excelData?.length || 0} {t("reports.rows", "صف")}
                  </Badge>
                  <Button size="xs" variant="ghost" colorScheme="red" onClick={removeExcelFile}>
                    {t("general.remove", "إزالة")}
                  </Button>
                </HStack>
              </HStack>
            </Box>
          )}
          <HStack spacing={1} fontSize="xs" color="gray.500">
            <Icon as={FaInfoCircle} />
            <Text>
              {t("reports.excelWillBeAnalyzed", "سيتم تحليل بيانات Excel مع بيانات النظام في التحليل الذكي")}
            </Text>
          </HStack>
        </VStack>
      </CardBody>
    </Card>
  );
}
